module.exports = function(h, row, that) {
    if (row.mode == 1) {
        return '+ ' + that.currency + ' ' + row.amount;
    } else if (row.mode == 2) {
        return '- ' + that.currency + ' ' + row.amount;
    } else {
        let amount = row.amount.replace(/(\.[0-9]*?)0+$/, '$1');
        return amount.replace(/\.$/, '') + ' %';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/discount/colums/amount.jsx